// extracted by mini-css-extract-plugin
module.exports = {"User_Registration":"UserRegistration_User_Registration__jga22"};